/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputMergeDivisions
 */
export interface InputMergeDivisions {
    /**
     * 
     * @type {number}
     * @memberof InputMergeDivisions
     */
    division1Id: number;
    /**
     * 
     * @type {number}
     * @memberof InputMergeDivisions
     */
    division2Id: number;
}

/**
 * Check if a given object implements the InputMergeDivisions interface.
 */
export function instanceOfInputMergeDivisions(value: object): boolean {
    if (!('division1Id' in value)) return false;
    if (!('division2Id' in value)) return false;
    return true;
}

export function InputMergeDivisionsFromJSON(json: any): InputMergeDivisions {
    return InputMergeDivisionsFromJSONTyped(json, false);
}

export function InputMergeDivisionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputMergeDivisions {
    if (json == null) {
        return json;
    }
    return {
        
        'division1Id': json['division1Id'],
        'division2Id': json['division2Id'],
    };
}

export function InputMergeDivisionsToJSON(value?: InputMergeDivisions | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'division1Id': value['division1Id'],
        'division2Id': value['division2Id'],
    };
}

